<template>
  <span class="tag ri-small-bold-body" :style="tagStyles">{{ text }}</span>
</template>

<script>
import Colors from '../scss/riseup-js-colors.module.scss';

export default {
  name: 'Tag',
  props: {
    text: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: Colors.riseupBlack,
    },
    textColor: {
      type: String,
      required: false,
      default: Colors.riseupWhite,
    },
  },
  computed: {
    tagStyles() {
      return {
        backgroundColor: this.backgroundColor,
        color: this.textColor,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/border-radius";

.tag {
  border-radius: $label-border-radius;
  padding: 1px 4px;
}
</style>
